<section id="portfolio" class="portfolio  white-bg ">
  <div class="section-inner">
    <div class="nav_title">
      <div class="overlay_image">
        <h2 class="" >
          Profile Details
        </h2>
      </div>
    </div>
  <div class="row about_page">
        <div class="nav_menu sidenav" id="mySidenav">
        
          <ul>
            <li class="listbtun " *ngFor="let list of PersonalMenus">
              <a [routerLink]="list.personal_path" class="text-uppercase nav_button btn " routerLinkActive="active"
                (click)="closeNav()"> {{list.personal_title}}</a>
            </li>
            <li class="listbtun">
              <a href="./home" (click)="logout()" class="text-uppercase nav_button btn ">
                Logout
              </a>
            </li>
          </ul>
    </div>
    <div class="navdisplay">
      <router-outlet></router-outlet>
    </div>
  </div>

  </div>
</section>